import React from 'react'
import BtnPrimary from '../element/Buttons/btnPrimary';
import Dialog from '../element/Dialog';

const ConfirmationModal = ({ 
  dialogOpen, 
  onDialogClose, 
  title = "Success!", 
  message = "Your action has been successfully completed.",
  onConfirm,
  showYesNo = false
}) => {

    const handleOk = () => {
        onDialogClose();
    };

    const handleYes = async () => {
        if (onConfirm) {
            await onConfirm();
        }
        onDialogClose();
    };

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            width={380}
            bodyOpenClassName="overflow-hidden"
        >
            <div className="flex flex-col items-center justify-center pt-6 px-6 pb-6 relative">

                {/* Icon */}
                {showYesNo ? (
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                        <circle cx="30" cy="30" r="30" fill="#FEF3C7" />
                        <path d="M30 18V34M30 42V44" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="30" cy="30" r="24" fill="none" stroke="#F59E0B" strokeWidth="2" />
                    </svg>
                ) : (
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                        <circle cx="30" cy="30" r="30" fill="#E6F7EC" />
                        <path d="M42 22L27 37L18 28" stroke="#2EB872" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                )}

                {/* Close Icon */}
                <button
                    onClick={onDialogClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24">
                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                {/* Title */}
                <h3 className="swal-title-success mt-4 text-center">
                    {title}
                </h3>

                {/* Message */}
                <p className="custom-message mt-2 mb-6">
                    {message}
                </p>

                {/* Buttons */}
                {showYesNo ? (
                    <div className="w-full flex gap-3">
                        <button
                            onClick={onDialogClose}
                            className="whiteBtnShadow btn border border-gray-100 block w-1/2 rounded-lg bg-[#FFF4E5] text-gray-700 text-sm font-semibold hover:bg-[#FFE4CC] transition-colors"
                        >
                            No
                        </button>
                        <BtnPrimary
                            onClick={handleYes}
                            className="flex-1"
                            style={{ backgroundColor: '#FF8E1C', borderColor: '#FF8E1C' }}
                        >
                            Yes
                        </BtnPrimary>
                    </div>
                ) : (
                    <BtnPrimary
                        onClick={handleOk}
                        className="w-full"
                        style={{ backgroundColor: '#2EB872', borderColor: '#2EB872' }}
                    >
                        OK
                    </BtnPrimary>
                )}
            </div>
        </Dialog>
    );
};

export default ConfirmationModal;
